import { useChainId } from "lib/chains";
import useSWR from "swr";
import { useWeb3React } from "@web3-react/core";
import { useLiquidityEventContract } from "pages/Event/hooks/blockchain/contracts/useLiquidityEventContract";
import { BigNumber } from "@ethersproject/bignumber";
import React from "react";

export const useEventGetAmountsOut = (amountIn: BigNumber, { isPaused = false } = {}) => {
  const { chainId } = useChainId();
  const { active } = useWeb3React();
  const eventContract = useLiquidityEventContract();
  const [fetcherAmountIn, setFetcherAmountIn] = React.useState<BigNumber | null>(null);
  const isPending = React.useMemo(() => {
    if (!fetcherAmountIn) {
      return false;
    }
    if (isPaused) {
      return false;
    }
    return amountIn !== fetcherAmountIn;
  }, [amountIn, fetcherAmountIn, isPaused]);

  const query = useSWR<{ amountsOut: BigNumber }>(
    [`LiquidityEvent:amounts-out:${active}`, chainId, amountIn],
    async ([, , _amountIn]) => {
      try {
        const [amountsOut] = await Promise.all([eventContract.getAmountsOut(amountIn)]);

        setFetcherAmountIn(_amountIn);

        return {
          amountsOut,
        };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);

        return {
          amountsOut: BigNumber.from(0),
        };
      }
    },
    {
      isPaused: () => isPaused,
    }
  );

  return {
    query,
    isPending,
  };
};
